import { render, staticRenderFns } from "./KundeWohnung.vue?vue&type=template&id=59c16e20&"
import script from "./KundeWohnung.vue?vue&type=script&lang=js&"
export * from "./KundeWohnung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports